import { gql } from '@apollo/client';

export const relationTypesQuery = gql`
  query RelationTypes {
    relationTypes {
      id
      name
    }
  }
`;
